// extracted by mini-css-extract-plugin
export default {"pageFadeInAnimate":"App_pageFadeInAnimate__-vxOQ","fadein":"App_fadein__6rnw+"};